import Vue from 'vue'
import axios from 'axios'
const AdminAPI = {
  data: {
  },
  setLogging (doLogging, clientNr, fnSuccess, fnError) {
    var url = Vue.prototype.storage.host() + '/ajaxGetBankData.php'
    Vue.prototype.$api.showIdle()
    let reqData = {
      userID: Vue.prototype.storage.getUserId(),
      type: 'CONFIG-LOGGING',
      value: 0,
      clientNr: 463
    }
    if (clientNr) {
      reqData.clientNr = clientNr
    }
    if (doLogging) {
      reqData.value = 1
    }

    axios({
      method: 'post',
      data: JSON.stringify(reqData),
      url: url,
      responseType: 'json'
    })
      .then(function (response) {
        Vue.prototype.$api.hideIdle()
        if (fnSuccess) {
          fnSuccess(response.data)
        }
      }, function (error) {
        Vue.prototype.$api.hideIdle()
        Vue.prototype.$eventHub.$emit('OnShowError', error)
        if (fnError) {
          fnError(error, status, error)
        } else {
          console.error('error')
          console.error(error)
          console.log(status)
        }
      })
  },
  setDebugging (doDebug, clientNr, fnSuccess, fnError) {
    var url = Vue.prototype.storage.host() + '/ajaxGetBankData.php'
    Vue.prototype.$api.showIdle()
    let reqData = {
      userID: Vue.prototype.storage.getUserId(),
      type: 'CONFIG-DEBUG',
      value: 0,
      clientNr: 463
    }
    if (clientNr) {
      reqData.clientNr = clientNr
    }
    if (doDebug) {
      reqData.value = 1
    }
    axios({
      method: 'post',
      data: JSON.stringify(reqData),
      url: url,
      responseType: 'json'
    })
      .then(function (response) {
        Vue.prototype.$api.hideIdle()
        if (fnSuccess) {
          fnSuccess(response.data)
        }
      }, function (error) {
        Vue.prototype.$api.hideIdle()
        Vue.prototype.$eventHub.$emit('OnShowError', error)
        if (fnError) {
          fnError(error, status, error)
        } else {
          console.error('error')
          console.error(error)
          console.log(status)
        }
      })
  }
}
export default AdminAPI



// WEBPACK FOOTER //
// ./src/components/admin/adminApi.js